<div class="loader" *ngIf="status$ | async">
	<span class="spinner-border"></span>
</div>
